module.exports = __webpack_public_path__ + "static/media/bg-2.32bbbe49.png";